"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ListingRoot = styled_components_1.default.table `
  margin: 0px 0px 20px 0px;
  width: 100%;
  border-collapse: collapse;
  border-radius: 2px;
  border-spacing: 0;
  table-layout: auto;
`;
ListingRoot.displayName = "ListingRoot";
class Listing extends React.PureComponent {
    render() {
        return (React.createElement(ListingRoot, null,
            React.createElement("tbody", null, this.props.children)));
    }
}
exports.Listing = Listing;
Listing.defaultProps = {
    children: null
};
exports.default = Listing;
